import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import useUser from '../../../contexts/hooks/useUser'
import SafeChargingInfo from '../../../modals/eNodeInit/electricCar/SafeChargingInfo'
import SmartChargeInfoDone from '../../../modals/eNodeInit/electricCar/SmartChargeInfoDone'
import SmartChargingAdditionalInfo from '../../../modals/eNodeInit/electricCar/SmartChargingAdditionalInfo'
import SmartChargingTimeLimit from '../../../modals/eNodeInit/electricCar/SmartChargingTimeLimit'
import { trpc } from '../../../modules/trpc'
import PageWrapper from '../../../wrappers/pageWrapper/PageWrapper'
import AddChargingStation from '../electricCar/addChargingStation/AddChargingStation'

const ElectricCarSetup: React.FC = () => {
	const { user, setUser } = useUser()
	const history = useHistory()
	const utils = trpc.useContext()
	const [phase, setPhase] = useState(1)

	const { data: vehicles, isLoading: vehiclesLoading } = trpc.eNode.vehicles.get.useQuery(
		{ hashedPid: user?.hashedPid ?? '' },
		{ enabled: Boolean(user?.hashedPid) }
	)

	const { data: locations, isLoading: locationsLoading } =
		trpc.eNode.locations.getAllUserLocations.useQuery(
			{ hashedPid: user?.hashedPid ?? '' },
			{ enabled: Boolean(user?.hashedPid) }
		)

	const setSmartChargingPolicy = trpc.eNode.charging.setSmartChargingPolicy.useMutation()

	useEffect(() => {
		if (phase === 1 && !locationsLoading && locations?.data !== undefined) {
			if (locations?.data.length > 0) setPhase(2)
		}
	}, [locations, locationsLoading])

	useEffect(() => {
		if (!user) return
		setUser({ vehicleLinked: true })
		utils.eNode.invalidate()
		utils.objects.getEnergyReport.invalidate()
	}, [])

	useEffect(() => {
		if (!user || !vehicles) return
		vehicles
			.filter(vehicle => !vehicle.smartChargingPolicy.isEnabled)
			.forEach(vehicle => {
				setSmartChargingPolicy.mutate({
					hashedPid: user.hashedPid!,
					vehicleId: vehicle.id,
					options: { deadline: '08:00', isEnabled: true, minimumChargeLimit: 20 },
				})
			})
	}, [vehicles?.length])

	const goForward = () => setPhase(p => p + 1)

	if (phase === 1 && locationsLoading) return null

	if (phase === 1)
		return (
			<AddChargingStation
				vehicles={(vehicles ?? []) as ENodeVehicle[]}
				goForward={goForward}
				vehiclesLoading={vehiclesLoading}
				backPath='/devices'
			/>
		)

	return (
		<PageWrapper page='addElectricCar' appBarOptions={{ backPath: '/devices' }}>
			{phase === 2 && <SafeChargingInfo goForward={goForward} />}
			{phase === 3 && <SmartChargingAdditionalInfo goForward={goForward} />}
			{phase === 4 && (
				<SmartChargingTimeLimit
					goForward={goForward}
					vehicles={(vehicles ?? []) as ENodeVehicle[]}
				/>
			)}
			{phase === 5 && <SmartChargeInfoDone onClose={() => history.push('/devices')} />}
		</PageWrapper>
	)
}

export default ElectricCarSetup
